module.exports = __webpack_public_path__ + "static/media/lightHeart.43334a39.svg";